















import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import { DxButton } from 'devextreme-vue';
import AgentSetup from '@/components/activity-planner/agent-setup.vue';

@Component({
  components: {
    AgentSetup,    
    DxButton,
    PageTitle
  }
})
export default class AgentSetupPage extends Vue {
  public $refs: Vue['$refs'] & {
    agentSetup?: AgentSetup;    
  } = {};

  refreshDataGrid() {
    if (this.$refs.agentSetup) {
      (this.$refs.agentSetup as any).refreshDataGrid();
    }
  }

  openCreateAgentForm() {
    if (this.$refs.agentSetup) {
      (this.$refs.agentSetup as any).showCreateNewAgent();
    }
  }

  openLinkAgentForm() {
    if (this.$refs.agentSetup) {
      (this.$refs.agentSetup as any).showLinkAgent();
    }
  }
}
